import { observer } from "mobx-react-lite";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { constRoute } from "@utils/route";
import SuperAdminLayout from "@components/layout/superadmin-layout/SuperAdminLayout";
import SuperAdminLogin from "@components/pages/SuperAdmin/SuperAdminLogin";

const DefaultLayout = observer(() => {
  const navigate = useNavigate();
  const location = useLocation();
  const [ready, setReady] = useState(false);

  const masterToken = localStorage.getItem("master_token");
  const isLoginPage = location.pathname === constRoute.masteradminLogin;

  useEffect(() => {
    if (!masterToken && !isLoginPage) {
      navigate(constRoute.masteradminLogin, { replace: true });
    }

    if (masterToken && isLoginPage) {
      navigate(constRoute.masteradminDashboard, { replace: true });
    }

    setReady(true);
  }, [masterToken, navigate, isLoginPage]);

  if (!ready) {
    return null;
  }

  return masterToken ? <SuperAdminLayout /> : <SuperAdminLogin />;
});

export default DefaultLayout;
